export default __webpack_public_path__ + "static/media/approvePlanIcon.a7fdfa39.svg";